module.exports = __webpack_public_path__ + "img/fullsizeoutput_9a4a.9cc9f056.9cc9f056.jpeg";